// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperModal-cls1_mSz","cls2":"MultiPaperModal-cls2_hWB MultiPaperModal-cls1_mSz"};